function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.006 36C82.012 28.8264 76.2015 23.0061 69.0279 23.0001 66.0937 22.9976 63.245 23.9887 60.946 25.812 60.2924 18.6654 53.9692 13.4018 46.8226 14.0554 40.5813 14.6262 35.6368 19.5707 35.066 25.812 29.4421 21.3559 21.2707 22.3025 16.8146 27.9264 12.3585 33.5502 13.3051 41.7217 18.929 46.1778 20.959 47.7863 23.4235 48.7513 26.006 48.949L26.006 70 70.006 70 70.006 48.949C76.7747 48.4307 82.0033 42.7886 82.006 36Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 26.006,
  y: 74,
  width: 44,
  height: 8,
  fill: "currentColor"
});

var SvgChefhat = function SvgChefhat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "Icons_ChefHat",
    overflow: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChefhat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chefhat.0c7e303c.svg";
export { ForwardRef as ReactComponent };